/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useContext, useMemo} from 'react'

import Context from '@s-ui/react-context'
import {filterBasicTypes} from '@adv-mt/mt-filter-basic'
import {filterWrapperBasicTypes} from '@adv-mt/mt-filter-wrapper-basic'

import {FILTERS_PLACES} from '../config.js'

const useFilters = ({listingSectionId, place, hasInstalment}) => {
  const {domain} = useContext(Context)

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('searchFilters')
  const {FILTERS_GROUPS_IDS} = config.get('filtersGroups')
  const {LISTING_SECTION_IDS} = config.get('COMMON')

  const filtersConfig = useMemo(() => {
    return {
      [FILTER_NAMES.HAS_INSTALMENT]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.BUTTON_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.HAS_RESERVATION]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.HAS_ONLINE_FINANCING]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.PRICE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: hasInstalment ? filterBasicTypes.SINGLE_SELECTION : filterBasicTypes.INPUT_NUMBER,
          wrapper: hasInstalment ? filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE : filterWrapperBasicTypes.EMBEDDED
        },
        [FILTERS_PLACES.MODAL]: {
          type: hasInstalment ? filterBasicTypes.SINGLE_SELECTION : filterBasicTypes.INPUT_NUMBER,
          wrapper: hasInstalment ? filterWrapperBasicTypes.MODAL_POPOVERS_AUTOCLOSE : filterWrapperBasicTypes.EMBEDDED
        },
        [FILTERS_PLACES.LITE]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.CENTER_TO_CUSTOM_RELATIVE_POPOVER_TABS_AUTOCLOSE_SCROLL_INTO_VIEW
        }
      },
      [FILTER_NAMES.PROVINCE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.MULTI_SELECTION_NESTED,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVER_WITH_SEARCH_BAR
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.MULTI_SELECTION_NESTED,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVER_WITH_SEARCH_BAR
        },
        [FILTERS_PLACES.LITE]: {
          type: filterBasicTypes.MULTI_SELECTION_NESTED,
          wrapper: filterWrapperBasicTypes.CENTER_TO_CUSTOM_RELATIVE_POPOVER_SCROLL_INTO_VIEW_WITH_SEARCH_BAR
        }
      },
      [FILTER_NAMES.ONLY_PENINSULA]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.RATING]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.SELLER_TYPE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.VEHICLE_STATE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.BUTTON_GROUP_SINGLE_SELECTION_GRID,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.BUTTON_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.LITE]: {
          type: filterBasicTypes.TAG_GROUP_SINGLE_SELECTION_GRID,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.OFFER_TYPE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type:
            listingSectionId === LISTING_SECTION_IDS.ALL_VEHICLES
              ? filterBasicTypes.BUTTON_GROUP_SINGLE_SELECTION_GRID
              : filterBasicTypes.SINGLE_SELECTION,
          wrapper:
            listingSectionId === LISTING_SECTION_IDS.ALL_VEHICLES
              ? filterWrapperBasicTypes.NONE
              : filterWrapperBasicTypes.RIGHT_POPOVER_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type:
            listingSectionId === LISTING_SECTION_IDS.ALL_VEHICLES
              ? filterBasicTypes.BUTTON_GROUP_SINGLE_SELECTION
              : filterBasicTypes.SINGLE_SELECTION,
          wrapper:
            listingSectionId === LISTING_SECTION_IDS.ALL_VEHICLES
              ? filterWrapperBasicTypes.NONE
              : filterWrapperBasicTypes.MODAL_POPOVER_AUTOCLOSE
        },
        [FILTERS_PLACES.LITE]: {
          type: filterBasicTypes.TAG_GROUP_SINGLE_SELECTION_GRID,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.CATEGORY_2]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.IMAGE_SINGLE_SELECTION_GRID_COLUMN_WITH_BORDER,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.IMAGE_SINGLE_SELECTION_WITH_BORDER_ROW_SCROLLABLE,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.MAKE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVER_AUTOCLOSE_WITH_SEARCH_BAR
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVER_WITH_SEARCH_BAR_AUTOCLOSE
        },
        [FILTERS_PLACES.LITE]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.CENTER_TO_CUSTOM_RELATIVE_POPOVER_AUTOCLOSE_SCROLL_INTO_VIEW_WITH_SEARCH_BAR
        }
      },
      [FILTER_NAMES.BODY_TYPE_CATEGORY]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVER_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVER_AUTOCLOSE
        }
      },
      [FILTER_NAMES.YEAR]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE
        }
      },
      [FILTER_NAMES.KMS]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.INPUT_NUMBER,
          wrapper: filterWrapperBasicTypes.EMBEDDED
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.INPUT_NUMBER,
          wrapper: filterWrapperBasicTypes.EMBEDDED
        }
      },
      [FILTER_NAMES.BODY_TYPE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.IMAGE_MULTI_SELECTION_GRID_COLUMN_WITH_BORDER,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.IMAGE_MULTI_SELECTION_GRID_COLUMN_WITH_BORDER,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.COLOR]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.TRANSMISSION_TYPE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.FUEL_TYPE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.ENVIRONMENTAL_LABEL]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.DRIVEN_WHEELS]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.HP]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE
        }
      },
      [FILTER_NAMES.LITRES]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE
        }
      },
      [FILTER_NAMES.DOOR]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE
        }
      },
      [FILTER_NAMES.SEAT]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE
        }
      },
      [FILTER_NAMES.LUGGAGE_CAPACITY]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.RADIO_BUTTON_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.RADIO_BUTTON_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.EQUIPMENTS]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.HAS_WARRANTY]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.IS_CERTIFIED]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.HAS_PHOTO]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.HAS_PRICE_DROP]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.HAS_STOCK]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.PRICE_RANK]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.CHECKBOX_GROUP_SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.NONE
        }
      },
      [FILTER_NAMES.ELECTRIC_AUTONOMY]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVER_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVER_AUTOCLOSE
        }
      },
      [FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE
        }
      },
      [FILTERS_GROUPS_IDS.ELECTRIC_CHARGING_TIME_GROUP_ID]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_WITH_FILTER_SELECTOR_AUTOCLOSE
        }
      },
      [FILTER_NAMES.MONTHLY_SUBSCRIPTION_FEE]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVERS_AUTOCLOSE
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVERS_HORIZONTAL_AUTOCLOSE
        },
        [FILTERS_PLACES.LITE]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.CENTER_TO_CUSTOM_RELATIVE_POPOVER_TABS_AUTOCLOSE_SCROLL_INTO_VIEW
        }
      },
      [FILTER_NAMES.MONTHLY_SUBSCRIPTION_COMMITMENT]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVER
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVER
        },
        [FILTERS_PLACES.LITE]: {
          type: filterBasicTypes.MULTI_SELECTION,
          wrapper: filterWrapperBasicTypes.BOTTOM_LEFT_POPOVER
        }
      },
      [FILTER_NAMES.MODEL]: {
        [FILTERS_PLACES.SIDEBAR]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.RIGHT_POPOVER_AUTOCLOSE_WITH_SEARCH_BAR
        },
        [FILTERS_PLACES.MODAL]: {
          type: filterBasicTypes.SINGLE_SELECTION,
          wrapper: filterWrapperBasicTypes.MODAL_POPOVER_WITH_SEARCH_BAR_AUTOCLOSE
        }
      }
    }
  }, [listingSectionId, place, hasInstalment])

  const getFilterConfigByPlace = useCallback(
    ({filterName}) => filtersConfig[filterName]?.[place] || {},
    [filtersConfig, place]
  )

  return {
    getFilterConfigByPlace
  }
}
export default useFilters
